import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { C } from "../constants";
import VaultLogo from "./VaultLogo";

const links = [
  ["/", "Home"], ["/about", "About"], ["/features", "Features"],
  ["/how-it-works", "How It Works"], ["/for-approvers", "For Approvers"], ["/for-users", "For Users"],
  ["/pricing", "Pricing"], ["/demo", "Demo & Tutorials"],
  ["/blog", "Blog"], ["/contact", "Contact"],
];

const complianceLinks = [
  ["/compliance", "Compliance Overview"],
  ["/privacy", "Privacy Policy"],
  ["/terms", "Terms of Service"],
];

const compliancePaths = complianceLinks.map(([to]) => to);

const navLinkStyle = (isActive) => ({
  background: isActive ? C.blueLight : "transparent",
  color: isActive ? C.blueDark : C.textMid,
  border: "none", borderRadius: 7, padding: "7px 10px",
  fontFamily: "'Nunito', sans-serif", fontWeight: 600, fontSize: 12.5,
  cursor: "pointer", transition: "all 0.2s", whiteSpace: "nowrap",
  textDecoration: "none"
});

function ComplianceDropdown({ location }) {
  const [open, setOpen] = useState(false);
  const isActive = compliancePaths.includes(location.pathname);

  return (
    <div
      style={{ position: "relative" }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <Link to="/compliance" style={{ ...navLinkStyle(isActive), display: "flex", alignItems: "center", gap: 3 }}>
        Compliance <span style={{ fontSize: 9, opacity: 0.6 }}>▼</span>
      </Link>
      {open && (
        <div style={{
          position: "absolute", top: "100%", left: "50%", transform: "translateX(-50%)",
          paddingTop: 6
        }}>
          <div style={{
            background: C.white, borderRadius: 10, padding: 6,
            border: `1px solid ${C.border}`,
            boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
            minWidth: 180
          }}>
            {complianceLinks.map(([to, label]) => (
              <Link key={to} to={to} onClick={() => setOpen(false)} style={{
                display: "block", padding: "9px 14px", borderRadius: 7,
                fontFamily: "'Nunito', sans-serif", fontWeight: 600, fontSize: 12.5,
                color: location.pathname === to ? C.blueDark : C.textMid,
                background: location.pathname === to ? C.blueLight : "transparent",
                textDecoration: "none", transition: "background 0.15s", whiteSpace: "nowrap"
              }}
                onMouseEnter={e => { if (location.pathname !== to) e.currentTarget.style.background = C.bg; }}
                onMouseLeave={e => { if (location.pathname !== to) e.currentTarget.style.background = "transparent"; }}
              >{label}</Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav style={{
      position: "sticky", top: 0, zIndex: 100,
      background: "rgba(255,255,255,0.96)", backdropFilter: "blur(14px)",
      borderBottom: `1px solid ${C.border}`,
      padding: "0 24px", height: 64, display: "flex", alignItems: "center", justifyContent: "space-between"
    }}>
      <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
        <VaultLogo size={34} />
        <span style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 20, color: C.text }}>
          Safe<span style={{ color: C.blue }}>Zapp</span>
        </span>
      </Link>
      <div style={{ display: "flex", gap: 1, alignItems: "center" }} className="sz-nav-desk">
        {links.map(([to, label]) => (
          <Link key={to} to={to} style={navLinkStyle(location.pathname === to)}>{label}</Link>
        ))}
        <ComplianceDropdown location={location} />
        <Link to="/pricing" style={{
          background: C.blue, color: "#fff", border: "none", borderRadius: 8,
          padding: "8px 16px", fontFamily: "'Nunito', sans-serif", fontWeight: 700,
          fontSize: 12.5, cursor: "pointer", marginLeft: 6, whiteSpace: "nowrap",
          textDecoration: "none"
        }}>Get Started</Link>
      </div>
      <button onClick={() => setMenuOpen(!menuOpen)} className="sz-nav-mob" style={{
        display: "none", background: "none", border: "none", fontSize: 24, cursor: "pointer", color: C.text
      }}>☰</button>
      {menuOpen && (
        <div style={{
          position: "absolute", top: 64, left: 0, right: 0,
          background: C.white, borderBottom: `1px solid ${C.border}`,
          padding: 12, display: "flex", flexDirection: "column", gap: 2, zIndex: 99
        }}>
          {links.map(([to, label]) => (
            <Link key={to} to={to} onClick={() => setMenuOpen(false)} style={{
              background: location.pathname === to ? C.blueLight : "transparent",
              color: location.pathname === to ? C.blue : C.text,
              border: "none", borderRadius: 8, padding: "12px 16px", textAlign: "left",
              fontFamily: "'Nunito', sans-serif", fontWeight: 600, fontSize: 15,
              textDecoration: "none", display: "block"
            }}>{label}</Link>
          ))}
          {/* Compliance sub-items in mobile */}
          <div style={{
            borderTop: `1px solid ${C.border}`, marginTop: 4, paddingTop: 6
          }}>
            <div style={{
              fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 11,
              color: C.textLight, textTransform: "uppercase", letterSpacing: 1,
              padding: "8px 16px 4px"
            }}>Compliance</div>
            {complianceLinks.map(([to, label]) => (
              <Link key={to} to={to} onClick={() => setMenuOpen(false)} style={{
                background: location.pathname === to ? C.blueLight : "transparent",
                color: location.pathname === to ? C.blue : C.text,
                border: "none", borderRadius: 8, padding: "10px 16px 10px 28px", textAlign: "left",
                fontFamily: "'Nunito', sans-serif", fontWeight: 600, fontSize: 14,
                textDecoration: "none", display: "block"
              }}>{label}</Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
